import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVerticalCircle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFlipVerticalCircle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.8 12.015a4.4 4.4 0 0 0 0-8.03V2.696a5.6 5.6 0 0 1 0 10.606zM7.407 1.398a.6.6 0 0 1 1.199 0V14.6a.6.6 0 1 1-1.2 0zm-5 6.313A5.6 5.6 0 0 1 6.2 2.696v1.288a4.4 4.4 0 0 0 0 8.03v1.289a5.6 5.6 0 0 1-3.801-5.304z"
            />
        </svg>
    );
}
export default memo(IconFlipVerticalCircle16);
